<template lang="pug">
  .dashboard-view
    v-container.pa-0(style="max-width:600px")
      .billing-warning(v-if="member && member.id === company.primary_owner")
        pending-payments(:company="company")
      yezza-pay-notice(:company="company")

</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import PendingPayments from '@/components/billing/PendingPayments.vue'
import YezzaPayNotice from '@/components/dashboard/YezzaPayNotice'

export default {
  name: 'Dashboard',
  components: {
    PendingPayments,
    YezzaPayNotice
  },
  props: ['company', 'menu'],
  data: () => ({
  }),
  computed: {
    ...mapState('subscriptions', ['genesData']),
    ...mapState('user', ['member']),
    ...mapGetters({ pagePermissions: 'permission/getPagePermissions' })
  },
  watch: {
    genesData () {
      this.checkOsType()
    },
    pagePermissions: {
      handler() {
        this.checkOsType()
      },
      deep: true
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    checkOsType () {
      if (this.genesData.find(f => f.feature === 'YZ_CLINIC' || f.feature === 'YZ_CMS')) {
        if (this.company.genes.find(gene => gene.feature === 'group_management')) {
          this.$router.push('/admin/clinic/leads').catch(() => {})
        }
        else if (this.Auth('page', '/admin/clinic/registration')) {
          this.$router.push('/admin/clinic/registration').catch(() => {})
        } else if (this.Auth('page', '/admin/clinic/appointment')) {
          this.$router.push('/admin/clinic/appointment').catch(() => {})
        } else if (this.Auth('page', '/admin/clinic/consultation')) {
          this.$router.push('/admin/clinic/consultation').catch(() => {})
        }
      } else if (this.genesData.find(f => f.feature === 'YZ_MARKETING')) {
        this.$router.push('/admin/clinic/marketing').catch(() => {})
      } else if (this.genesData.find(f => f.feature === 'YZ_REVIEW')) {
        this.$router.push('/admin/clinic/review').catch(() => {})
      } else if (this.genesData.find(f => f.feature === 'YZ_PURCHASE_HUB')) {
        this.$router.push('/admin/clinic/purchase-hub').catch(() => {})
      }
    }
  }
}
</script>

<style>
</style>

<style lang="scss">
</style>
